import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const RemoveCircleIcon = props => (
  <SvgIcon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
    <path
      fill="#000"
      fillRule="nonzero"
      d="M4 7.2v1.6h8V7.2H4zM8 0C3.584 0 0 3.584 0 8s3.584 8 8 8 8-3.584 8-8-3.584-8-8-8zm0 14.4A6.408 6.408 0 0 1 1.6 8c0-3.528 2.872-6.4 6.4-6.4 3.528 0 6.4 2.872 6.4 6.4 0 3.528-2.872 6.4-6.4 6.4z"
    />
  </SvgIcon>
);

export default RemoveCircleIcon;
